import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Container, Form, Button, Card, Alert } from "react-bootstrap";
import Layout from "../layout";
import SuccessModalOrder from "../../component/ModalSuccessOrder";

const LogistikTransaksi = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [aktualWaktuTiba, setAktualWaktuTiba] = useState("");
  const [biayaTransportasi, setBiayaTransportasi] = useState("");
  const [kondisiPengiriman, setKondisiPengiriman] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [statusOrder, setStatusOrder] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState(""); 
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!id) {
      setMsg("Invalid order ID.");
      return;
    }

    if (!token) {
      setMsg("No token found, please login again.");
      return;
    }

    const fetchData = async () => {
      try {
        console.log("Fetching order data for ID:", id);
        const response = await axios.get(
          `https://c-greenproject.org:8000/orderberlangsung`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log("Data order dari backend:", response.data);
        if (!response.data) {
          setMsg("Order data not found.");
          return;
        }

        const data = response.data;
        setStatusOrder(data.statusOrder);
        setAktualWaktuTiba(data.aktualWaktuTiba || "");
        setBiayaTransportasi(data.biayaTransportasi || "");
        setKondisiPengiriman(data.kondisiPengiriman || "");
      } catch (error) {
        console.error("Error fetching data:", error);
        setMsg("Terjadi kesalahan dalam mengambil data.");
      }
    };

    fetchData();
  }, [id, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!id) {
      setMsg("ID produk tidak ditemukan.");
      return;
    }

    setLoading(true);
    const payload = {
      aktualWaktuTiba: `${aktualWaktuTiba}:00`,
      biayaTransportasi: Number(biayaTransportasi), 
      kondisiPengiriman: kondisiPengiriman.trim(),
    };

    console.log("Mengirim PATCH dengan payload:", payload);

    try {
      const response = await axios.patch(
        `https://c-greenproject.org:8000/inputtransaksi/${id}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      console.log("Response sukses:", response.data);

      setModalMessage("Data transaksi logistik telah dicatat.");
      setShowModal(true);
    } catch (error) {
      console.error("Error response:", error);
      setMsg(error.response?.data?.msg || "Gagal mencatat transaksi logistik.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <Container>
        <h2 className="my-4">
          <strong>Input Data Logistik</strong>
        </h2>
        <Card className="p-4">
          {msg && (
            <Alert variant="danger" className="text-center">
              {msg}
            </Alert>
          )}
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Aktual Waktu Tiba</Form.Label>
              <Form.Control
                type="time"
                value={aktualWaktuTiba}
                onChange={(e) => setAktualWaktuTiba(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Biaya Transportasi</Form.Label>
              <Form.Control
                type="number"
                value={biayaTransportasi}
                onChange={(e) => setBiayaTransportasi(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Kondisi Pengiriman</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={kondisiPengiriman}
                onChange={(e) => setKondisiPengiriman(e.target.value)}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? "Mengirim..." : "Kirim Data"}
            </Button>
          </Form>
        </Card>
      </Container>

      <SuccessModalOrder
        show={showModal}
        message={modalMessage}
        onClose={() => {
          setShowModal(false);
          navigate("/order"); 
        }}
      />
    </Layout>
  );
};

export default LogistikTransaksi;
